import React from 'react';
import { Heading } from '..';
import css from '../../containers/ListingPage/ListingPage.module.css';
import { FaCalendarDay, FaBan } from 'react-icons/fa';

const SectionTours = props => {
  const { heading, selectedOptions = [], options = [] } = props;

  if (!heading || selectedOptions.length === 0) {
    return null;
  }

  const optionLabelMap = options.reduce((acc, opt) => {
    acc[opt.key] = opt.label;
    return acc;
  }, {});

  return (
    <section className={css.sectionCleaningFacilities}>
      <Heading as="h2" rootClassName={css.sectionHeading}>
        {heading}
      </Heading>
      <ul className={css.cleaningFacilitiesList}>
        {selectedOptions.map(optionKey => {
          const isNoOption = optionKey === 'no';
          const IconComponent = isNoOption ? FaBan : FaCalendarDay;
          return (
            <li key={optionKey} className={css.multiEnumItem}>
              <span className={css.facilityIcon}>
                <IconComponent />
              </span>
              <span>{optionLabelMap[optionKey] || optionKey}</span>
            </li>
          );
        })}
      </ul>
    </section>
  );
};

export default SectionTours;
